import apiClient from '../../../services/apiClient';
import type { FAQ, FAQFormData, FAQStats, AgentTestResponse } from '../types/faq.types';

const BASE_URL = '/faq/api/entries';

export class FAQApiService {
  static async getFAQs(filters?: any, page = 1) {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.sortBy) params.append('ordering', `${filters.sortOrder === 'desc' ? '-' : ''}${filters.sortBy}`);
    params.append('page', page.toString());

    const response = await apiClient.get(`${BASE_URL}/?${params.toString()}`);
    return response.data;
  }

  static async createFAQ(data: FAQFormData): Promise<FAQ> {
    const response = await apiClient.post(`${BASE_URL}/`, data);
    return response.data;
  }

  static async updateFAQ(id: number, data: FAQFormData): Promise<FAQ> {
    const response = await apiClient.put(`${BASE_URL}/${id}/`, data);
    return response.data;
  }

  static async deleteFAQ(id: number): Promise<void> {
    await apiClient.delete(`${BASE_URL}/${id}/`);
  }

  static async testAgent(question: string): Promise<AgentTestResponse> {
    const response = await apiClient.post(`${BASE_URL}/test_agent/`, { question });
    return response.data;
  }

  static async getFAQStats(): Promise<FAQStats> {
    const response = await apiClient.get(`${BASE_URL}/stats/`);
    return response.data;
  }

  static async bulkImportFAQs(faqs: Array<{question: string, answer: string}>) {
    const response = await apiClient.post(`${BASE_URL}/bulk_import/`, { faqs });
    return response.data;
  }
}
